export function getRecordingsStorageLowerBoundary({ startOfDay, subMonths, subYears, storageDuration }) {
  if (Number.isFinite(storageDuration) && storageDuration > 0) {
    return startOfDay(subMonths(new Date(), storageDuration));
  }

  return startOfDay(subYears(new Date(), 2));
}
